import ApiService from './api.service'

const PaymentService = {
    disconnectStripe: async function() {
        await ApiService.post(`stripe/disconnect`);
    },
    getAccountLink: async function(params = '') {
        const response = await ApiService.get(`stripe/account-link${params}`);
        return response.data.data;
    },
    getPaymentIntent: async function(campaignHash, data) {
        const response = await ApiService.post(`campaign/${campaignHash}/create-payment-intent`, data);
        return response.data.data
    },
    addDonor: async function(data) {
        const response = await ApiService.post('donation', data);
        return response.data.data
    }
}

export default PaymentService

export { PaymentService }
